import { OnBandSurface } from '@/components/PageHeading';

/**
 * The band across the top of a booking's counter — hand over, take back, check, settle, a payment —
 * the phone's band on the website: back to the booking, which booking and whose, and what this
 * screen does. Every booking screen opens on one since 2026-10-22, so a clerk always knows where
 * they are and which way is back.
 *
 * <p>
 * On the theme's deep band colour with the title in the serif, the same band as every page heading
 * since the boutique theme (2026-10-23), rather than the accent it first wore. White is written as a
 * literal: the template's `text-white` is a token that turns dark in the dark theme.
 * </p>
 */
export function CounterBand({
  eyebrow,
  title,
  onBack,
  backLabel = 'Back to the booking',
  trailing,
}: {
  /** "BK-2026-27-0142 · Bhavesh Kansagra". */
  eyebrow: string;
  title: string;
  onBack: () => void;
  backLabel?: string;
  /** Something said on the right — a progress bar, a count. */
  trailing?: React.ReactNode;
}) {
  return (
    <OnBandSurface>
      <div className="page-band mb-3 flex flex-wrap items-center gap-x-4 gap-y-2 !py-4">
        <button
          type="button"
          onClick={onBack}
          data-shortcut="back"
          aria-label={backLabel}
          className="flex size-9 cursor-pointer items-center justify-center rounded-lg text-[#ffffff] hover:bg-[#ffffff]/15"
        >
          <i className="icon icon-arrow-left text-[18px]" />
        </button>
        <div className="min-w-0">
          <p className="page-eyebrow mb-1 truncate">{eyebrow}</p>
          <h1 className="font-serif text-2xl leading-tight font-semibold text-[#ffffff]">
            {title}
          </h1>
        </div>
        {trailing && <div className="ms-auto text-[#ffffff]">{trailing}</div>}
      </div>
    </OnBandSurface>
  );
}
